import { ErrorMessages } from '@/constants/errorMessages';

const EmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PhoneCharactersPattern = /^\+?[\d\s().-]+$/;
const NonDigitsPattern = /\D/g;
const InternationalMinDigits = 8;
const InternationalMaxDigits = 15;
const DomesticDigits = 10;
const WebsitePattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/\S*)?$/i;

export function isEmailValid(email) {
  return EmailPattern.test(email.trim());
}

export function isPhoneValid(phone) {
  const trimmedPhone = phone.trim();
  if (!PhoneCharactersPattern.test(trimmedPhone)) return false;
  const digits = trimmedPhone.replace(NonDigitsPattern, '');
  if (trimmedPhone.startsWith('+')) {
    return digits.length >= InternationalMinDigits && digits.length <= InternationalMaxDigits;
  }
  return digits.length === DomesticDigits || (digits.length === DomesticDigits + 1 && digits.startsWith('1'));
}

export function isWebsiteValid(website) {
  return WebsitePattern.test(website.trim());
}

export function getRequiredError(value, message) {
  return value.trim() ? null : message;
}

export function getEmailError(email) {
  if (!email.trim()) return ErrorMessages.email.required;
  return isEmailValid(email) ? null : ErrorMessages.email.invalid;
}

export function getOptionalPhoneError(phone) {
  if (!phone.trim()) return null;
  return isPhoneValid(phone) ? null : ErrorMessages.phone.invalid;
}

export function getOptionalWebsiteError(website) {
  if (!website.trim()) return null;
  return isWebsiteValid(website) ? null : ErrorMessages.website.invalid;
}